import { Button } from "@chakra-ui/react";
import { shade } from "polished";
import { ReactNode } from "react";
import { validIfColorIsValid } from "../../../../utils/color";
interface DinamicSolidButtonProps {
  bg: string;
  children: ReactNode;
  color: string;
  onClick: () => void;
}

export function DinamicSolidButton({
  bg,
  color,
  children,
  onClick,
}: DinamicSolidButtonProps) {
  return (
    <Button
      bg={bg}
      color={color}
      onClick={onClick}
      _hover={{
        backgroundColor: shade(0.2, validIfColorIsValid(bg) ? bg : "#000000"),
      }}
      _active={{
        backgroundColor: shade(0.2, validIfColorIsValid(bg) ? bg : "#000000"),
      }}
    >
      {children}
    </Button>
  );
}
